<template>
  <v-data-table
    class="releases"
    :items="releases"
    :items-per-page="50"
    :footer-props="{'items-per-page-options':[15, 30, 50, 100, -1]}"
    :loading="busy"
    :headers="headers"
  >
    <template v-slot:item.created_at="{ value }">
      {{ value | datetime }}
    </template>

    <template v-slot:item.actions="{ item }">
      <ion-button
        fill="clear"
        @click="edit(item)"
      >
        <ion-icon
          :src="i.pencil"
          color="dark"
        />
      </ion-button>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { VDataTable } from 'vuetify/lib'
import { modalController } from '@modus/ionic-vue'

import Release from './Release'

export default {
  components: {
    VDataTable,
  },
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      busy: true
    }
  },
  computed: {
    ...mapGetters([
      'getReleasesForProject'
    ]),
    releases() {
      if(this.busy) {
        return []
      }

      return this.getReleasesForProject(this.project.id)
    },
    headers() {
      const headers = [
        {
          text: 'Created at',
          value: 'created_at'
        },
        {
          text: 'Version',
          value: 'commit.version'
        },
        {
          text: 'Build Number',
          value: 'commit.build_number'
        },
        {
          text: 'Release notes',
          value: 'release_notes'
        },
        {
          text: 'Release track',
          value: 'release_track'
        },
        {
          value: 'actions',
          sortable: false
        }
      ]

      return headers
    }
  },
  created() {
    this.fetchReleases()
  },
  methods: {
    fetchReleases() {
      this.$store.dispatch('fetchReleases', { project: this.project.id })
        .finally(() => this.busy = false)
    },
    getCommitUrl(sha) {
      return `${this.project.repository_base_url}/tree/${sha}`
    },
    async edit(release) {
      const commit = release.commit

      const modal = await modalController
        .create({
          component: Release,
          componentProps: {
            propsData: {
              commit,
              release
            }
          },
          cssClass: 'card-modal'
        })

      modal.present()
    }
  }
}
</script>

<style>
.releases tr td:nth-child(3) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 1px;
}
</style>
